import { render, staticRenderFns } from "./uiProductAmountSelector.vue?vue&type=template&id=affb9974&scoped=true"
import script from "./uiProductAmountSelector.vue?vue&type=script&lang=js"
export * from "./uiProductAmountSelector.vue?vue&type=script&lang=js"
import style0 from "./uiProductAmountSelector.vue?vue&type=style&index=0&id=affb9974&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "affb9974",
  null
  
)

export default component.exports